import { MenuItems } from './menu-items';

// Customer menu: Used for single-bot tenants (simplified bot-focused navigation)
// Ordered for customer/end-user experience vs internal admin view
export const customerMenu = [
  MenuItems.BotAdmin,
  MenuItems.BotGeneral,
  MenuItems.BotDashboard,
  MenuItems.ChatQueue,
  MenuItems.BotChannels,
  MenuItems.BotDialogs,
  MenuItems.BotDialogs2,
  MenuItems.BotCommands,
  MenuItems.BotPlaybooks,
  MenuItems.BotActions,
  MenuItems.Connectors,
  MenuItems.Users,
  MenuItems.BotRoles,
  MenuItems.BotOrganization,
  MenuItems.BotReports,
  MenuItems.BotEvents,
  MenuItems.BotForms,
  MenuItems.BotAudience,
  MenuItems.BotConversations,
  MenuItems.BotQueries,
  MenuItems.BotDialogMessages,
  MenuItems.BotTags,
  MenuItems.BotSettings,
  MenuItems.Help
];
